import type { FileName } from "@pdfking/structs"

import type { FileQuery } from "#public"

import { FolderPrefix } from "../public/utils/FolderPrefix"

/** Whether a key is one a FOLDER query asked for.
 *
 * This is the whole folder semantic for stores that keep a flat keyspace of
 * paths: inside the folder, no deeper than `deep` allows, and not hidden
 * unless asked for — a dot on any segment below the folder hides the key, the
 * same way a dot on a directory hides everything under it on a filesystem. */
export const FolderMemberQ = (
  { deep = true, hidden = false, path = "" as FileName }: FileQuery,
  key: FileName
): boolean => {
  const prefix = FolderPrefix(path)
  if (!key.startsWith(prefix)) return false

  const rest = key.slice(prefix.length)
  if (!rest) return false

  const segments = rest.split("/")
  if (!deep && segments.length > 1) return false

  return hidden || !segments.some(segment => segment.startsWith("."))
}
